import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '../auth/guards/auth.guard';
import { InspectionTypesComponent } from './pages/inspection-types/inspection-types.component';
import { InspectionTypeEditComponent } from './pages/inspection-type-edit/inspection-type-edit.component';
import { InspectionsComponent } from './pages/inspections/inspections.component';
import { InspectionsBulkComponent } from './pages/inspections-bulk/inspections-bulk.component';
import { InspectionCalendarComponent } from './pages/inspection-calendar/inspection-calendar.component';

const routes: Routes = [
  { path: 'workshop/inspections', component: InspectionsComponent, canActivate: [AuthGuard] },
  { path: 'workshop/inspections/calendar', component: InspectionCalendarComponent, canActivate: [AuthGuard] },
  { path: 'workshop/inspections/bulk', component: InspectionsBulkComponent, canActivate: [AuthGuard] },
  { path: 'workshop/inspection-types', component: InspectionTypesComponent, canActivate: [AuthGuard] },
  { path: 'workshop/inspection-types/new', component: InspectionTypeEditComponent, canActivate: [AuthGuard] },
  { path: 'workshop/inspection-types/edit/:id', component: InspectionTypeEditComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class VehicleInspectionsRoutingModule { }
